// extracted by mini-css-extract-plugin
export default {"EditNamePage":"styles_EditNamePage__q+u6+","fullWidth":"styles_fullWidth__LBtOf"};